var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip",staticClass:"tooltip"},[_vm._v(" ? "),_c('div',{directives:[{name:"pure-html",rawName:"v-pure-html",value:(_vm.text),expression:"text"}],ref:"tooltipText",staticClass:"tooltip-text",style:(_vm.currentTooltipStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }